var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.errNoticeShow
    ? _c("div", { staticClass: "popup", staticStyle: { zIndex: "200" } }, [
        _c("div", { staticClass: "content", attrs: { id: "noticeRemind" } }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\r\n            " +
                _vm._s(_vm.$t("language.paySystem.Notice")) +
                "\r\n            "
            ),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  return _vm.closePage()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pay-error-content" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("language.paySystem.tryAgain")))]),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("language.paySystem.contactPayment"))
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "bind-remind-footer" }, [
              _c("div", { staticClass: "error-button" }, [
                _c(
                  "button",
                  {
                    staticStyle: { "border-radius": "5Px", minWidth: "80Px" },
                    on: {
                      click: function($event) {
                        return _vm.closePage()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
                )
              ]),
              _vm._v(" "),
              _c("div")
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ef28e56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ef28e56","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/pay_system_popups/pay_error_notice_popup.vue
// module id = null
// module chunks = 